import { BaseService } from '@/core/base-service';

export default class QuestionService extends BaseService<any> {
  public constructor() {
    super('services/serviceauttech/api/question');
  }
}
